'use strict';

var Backbone = require('backbone'),
  _ = require('underscore'),
  mediator = require('../../js/mediator'),
  config = require('../../js/config'),

  EngineerListingView = Backbone.View.extend({

    events: {
      click: 'showMore'
    },

    initialize: function() {
      this.initialiseEvents();
    },

    initialiseEvents: function() {
      mediator.on('agentlist:hideshowmore', _.bind(this.hide, this));
    },

    hide: function() {

      this.inactive = true;
      this.$el.addClass(config.classes.refineProductResults)
        .text(this.$el.data('no-more-results'));
    },

    showMore: function(e) {
      e.preventDefault();
      mediator.trigger(config.events.engineer.loadMore);
      if (!this.inactive) {
        mediator.trigger(config.events.videoDesk.showMoreAgents);
      }
    }

  });

module.exports = EngineerListingView;



// WEBPACK FOOTER //
// ./assets/components/Engineer/EngineerListingView.js